import { render, staticRenderFns } from "./SearchAvailableResults.vue?vue&type=template&id=8b260956&"
import script from "./SearchAvailableResults.vue?vue&type=script&lang=ts&"
export * from "./SearchAvailableResults.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports